export class ClientAdd {
    name: string;
    applicationList: ApplicationList[];
    isActive: boolean;

    constructor(name: string, applicationList: ApplicationList[], isActive: boolean) {
        this.name = name;
        this.applicationList = applicationList;
        this.isActive = isActive;
    }
}

export class ApplicationList {
    id: string;
    applicationName: string;

    constructor(id: string, applicationName: string) {
        this.id = id;
    }

}
